import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const StrikeZoneWrapper = styled.div`
  position: relative;
  height: calc(100vh - 250px);

  .small,
  .medium,
  .large {
    width: 100%;
    .title {
      display: none;
    }
  }
`;

export const ViewTypeGroup = styled.div`
  position: absolute;
  bottom: 15px;
  left: 15px;

  color: ${grey};
  display: flex;
  flex-direction: column;
  gap: 10px;

  font-family: Inter;
  font-size: 11px;
  font-weight: 600;
  line-height: 10px;
`;

export const RadioItemWrapper = styled.div`
  display: flex;

  .MuiTypography-root {
    color: ${({ theme }) => theme.inputTextColor};
  }
`;
